// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1791887531534
      var cssReload = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  